'use client';

import { ComponentPropsWithoutRef } from 'react';
import { useIsInertBecauseOfMenu } from '../pageHeader/mainMenu/MainMenu.client';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { viewTransitionName } from '@/uiPrimitives/utility/viewTransitionNames.css';

export const PageFooterClient = ({
	className,
	...props
}: ComponentPropsWithoutRef<'footer'>) => {
	const inert = useIsInertBecauseOfMenu();

	return (
		<footer
			{...props}
			inert={inert}
			className={classes(
				className,
				// For any view-transition of the decision-tool, this element needs to be pushed down during the animation, which is only tracked when it has a viewTransitionName.
				viewTransitionName({ viewTransitionName: 'page-footer' }),
			)}
		/>
	);
};
